import api from '@/api'

export function fetchAgents () {
  return api.get('/agents/')
}

export function fetchAgentBySlug (agentSlug) {
  return api.get(`/agents/${agentSlug}/`)
}

export function searchAgents (filters) {
  const params = new URLSearchParams()
  for (const key in filters) {
    let value = filters[key]
    if (value.constructor === Array && value.length > 0) {
      value.forEach(param => {
        params.append(key, param)
      })
    } else if (value.constructor === String && value !== '') {
      params.append(key, value)
    }
  }

  return api.get('/agents/', { params: params })
}
